const CLOSE_DISTANCE = 110;

export function swipeToClose(sheet, { onClose, scroller = sheet, distance = CLOSE_DISTANCE } = {}) {
  let startY = null;
  let delta = 0;

  const draw = () => {
    sheet.style.transform = delta > 0 ? `translateY(${delta}px)` : "";
  };

  const reset = () => {
    startY = null;
    delta = 0;
    sheet.classList.remove("dragging");
    draw();
  };

  const start = (event) => {
    if (event.touches?.length !== 1 || scroller.scrollTop > 0) return;
    startY = event.touches[0].clientY;
    delta = 0;
    sheet.classList.add("dragging");
  };

  const move = (event) => {
    if (startY === null || event.touches?.length !== 1) return;
    const offset = event.touches[0].clientY - startY;
    if (offset <= 0 && delta <= 0) {
      startY = event.touches[0].clientY;
      return;
    }
    if (scroller.scrollTop > 0) return reset();
    if (event.cancelable) event.preventDefault();
    delta = Math.max(0, offset);
    draw();
  };

  const end = () => {
    if (startY === null) return;
    const closing = delta >= distance;
    reset();
    if (closing) onClose();
  };

  sheet.addEventListener("touchstart", start, { passive: true });
  sheet.addEventListener("touchmove", move, { passive: false });
  sheet.addEventListener("touchend", end);
  sheet.addEventListener("touchcancel", reset);

  return {
    get offset() {
      return delta;
    },
    detach() {
      sheet.removeEventListener("touchstart", start);
      sheet.removeEventListener("touchmove", move);
      sheet.removeEventListener("touchend", end);
      sheet.removeEventListener("touchcancel", reset);
      reset();
    }
  };
}
